import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.contract.sections.paymentMethods.title',
    defaultMessage: 'Payment methods',
    description: 'title of the payment methods section',
  },
  create: {
    title: {
      id: 'pages.contract.sections.paymentMethods.create.title',
      defaultMessage: 'Add payment method',
      description: 'title of the payment methods section',
    },
    button: {
      id: 'actions.add',
      defaultMessage: 'Add',
      description: 'label of the add button',
    },
  },
  delete: {
    disabledTooltip: {
      id: 'pages.contract.sections.paymentMethods.delete.disabledTooltip',
      defaultMessage: 'It is required to have one payment method.',
      description: 'title of the payment methods disabled delete button tooltip',
    },
  },
  empty: {
    id: 'pages.contract.sections.paymentMethods.empty',
    defaultMessage: 'No payment methods configured',
    description: 'empty message when no cards are found',
  },
  feedback: {
    paymentMethodAdded: {
      id: 'pages.contract.sections.paymentMethod.feedback.paymentMethodAdded',
      defaultMessage: 'Payment method added',
      description: 'payment method added feedback message',
    },
    paymentMethodNotAdded: {
      id: 'pages.contract.sections.paymentMethod.feedback.paymentMethodNotAdded',
      defaultMessage: 'Could not add payment method',
      description: 'payment method not added feedback message',
    },
    paymentMethodDeleted: {
      id: 'pages.contract.sections.paymentMethod.feedback.paymentMethodDeleted',
      defaultMessage: 'Payment method deleted',
      description: 'payment method deleted feedback message',
    },
    paymentMethodNotDeleted: {
      id: 'pages.contract.sections.paymentMethod.feedback.paymentMethodNotDeleted',
      defaultMessage: 'Could not delete payment method',
      description: 'payment method not deleted feedback message',
    },
  },
};

export default defineMessages(translations);
